
import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { ContainerReportModel } from "./container-report.model";

export class ContainerReportResponse extends GlobalResponseObject{
    data?: ContainerReportModel[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data string
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: ContainerReportModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}